export default "__VITE_ASSET__M76DuhG6__"